__webpack_require__.p = "/reports-chart-grid-adjustments/referrals/";